import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';


const ShowFastJobPost = ({ post: propPost }) => {
  const { id } = useParams();
  const [post, setPost] = useState(propPost || null);
  const [loading, setLoading] = useState(!propPost);

  useEffect(() => {
    console.log(id)
    if (!propPost && id) {
      axios.get(`https://kariyer.biyomed.net/api/posts/get-one-fast-post/${id}`)
        .then(res => {
          setPost(res.data.post);
          setLoading(false);
        })
        .catch(err => {
          console.error("API'den veri alınırken hata oluştu:", err);
          setLoading(false);
        });
    }
  }, [id, propPost]);

  if (loading) {
    return <div>Yükleniyor...</div>;
  }

  if (!post) {
    return <div>İlan bulunamadı.</div>;
  }

  const formattedDate = new Date(post?.created_at).toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const today = new Date().toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const companyLogoUrl = post?.company_logo
    ? (typeof post.company_logo === 'string'
      ? post.company_logo
      : URL.createObjectURL(post.company_logo))
    : null;

  return (
    <>
            <div className="jp_tittle_main_wrapper">
          <div className="jp_tittle_img_overlay" />
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="jp_tittle_heading_wrapper">
                  <div className="jp_tittle_heading">
                    <h2>{post?.position_name}</h2>
                  </div>
                  <div className="jp_tittle_breadcrumb_main_wrapper">
                    <div className="jp_tittle_breadcrumb_wrapper">
                      <ul>
                        <li>
                          <a href="/">Anasayfa</a> <i className="fa fa-angle-right" />
                        </li>
                        <li>
                          <a href="/all-posts">Tüm İlanlar</a> <i className="fa fa-angle-right" />
                        </li>
                        <li>{post?.position_name}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

<div className="jp_listing_sidebar_main_wrapper">
      <div className="container">
      <div className="row">
        <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
          <div className="jp_listing_left_sidebar_wrapper">
            {post?.qualifications ? <div className="jp_job_apply" style={{ marginTop: -40 }}>
              <h2>Aranan Nİtelİkler</h2>
              <div dangerouslySetInnerHTML={{ __html: post?.qualifications }} />
            </div> : ""}

            {post?.job_description ? <div className="jp_job_apply">
              <h2>İş Tanımı/Sorumluluklar</h2>
              <div dangerouslySetInnerHTML={{ __html: post?.job_description }} />
            </div> : ""}

            {post?.other_details ?
              <div className="jp_job_apply">
                <h2>DİĞER BİLGİLER</h2>
                <div dangerouslySetInnerHTML={{ __html: post?.other_details }} />
                {post?.job_link ? <div style={{ marginTop: 20 }}>
                </div> : ''}
              </div> : ""
            }
            <div className="jp_job_apply">
              <h2>Hakkımızda</h2>
              <p>{post.about_company}</p>
            </div>
          </div>
          <div className="jp_listing_left_bottom_sidebar_key_wrapper">
            <ul>
              <li>
                <i className="fa fa-tags" />
                Etiketler:
              </li>
              <li>
                <a href="/">{post?.position_tags}</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="jp_rightside_job_categories_wrapper jp_rightside_listing_single_wrapper">
                <div className="jp_rightside_job_categories_heading">
                  <h4>İlan Bilgileri</h4>
                </div>
                <div className="jp_jop_overview_img_wrapper">
                  <div className="jp_jop_overview_img">
                    <img
                      src={companyLogoUrl}
                      alt="post_img"
                      style={{
                        maxWidth: "90%",
                        maxHeight: "200px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </div>
                <div className="jp_job_listing_single_post_right_cont">
                  <div className="jp_job_listing_single_post_right_cont_wrapper">
                    <h4>{post?.position_name.length > 40 ? post?.position_name.slice(0, 40) + "..." : post?.position_name}</h4>
                    <p

                      onMouseEnter={(e) => (e.target.style.color = "black")}
                      onMouseLeave={(e) => (e.target.style.color = "#23c0e9")}
                      style={{
                        fontSize: "14px",
                        marginTop: 10,
                        cursor: "pointer",
                        color: "#23c0e9", // Varsayılan renk
                        transition: "color 0.2s ease-in-out", // Yumuşak geçiş efekti
                      }}
                    >
                      {post?.company_name.length > 40 ? post?.company_name.slice(0, 40) + "..." : post?.company_name}
                    </p>
                  </div>
                </div>
                <div className="jp_job_post_right_overview_btn_wrapper">
                  <div className="jp_job_post_right_overview_btn">
                    <ul>
                      <li>
                      </li>
                      <li>
                        <a style={{ backgroundColor: post?.job_type === "Is" ? '' : '#f7b248', marginRight: 20 }} href="/">
                          {post?.job_type === "Is" ? "İş İlanı" : post?.job_type === "Staj" ? "Staj İlanı" : post?.job_type}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="jp_listing_overview_list_outside_main_wrapper">
                  <div className="jp_listing_overview_list_main_wrapper">
                    <div className="jp_listing_list_icon">
                      <i className="fa fa-calendar" />
                    </div>
                    <div className="jp_listing_list_icon_cont_wrapper">
                      <ul>
                        <li>Yayımlama Tarihi:</li>
                        <li>{formattedDate}</li>
                      </ul>
                    </div>
                  </div>
                  <div className="jp_listing_overview_list_main_wrapper jp_listing_overview_list_main_wrapper2">
                    <div className="jp_listing_list_icon">
                      <i className="fa fa-map-marker" />
                    </div>
                    <div className="jp_listing_list_icon_cont_wrapper">
                      <ul>
                        <li>İl:</li>
                        <li>{post?.city}</li>
                      </ul>
                    </div>
                  </div>
                  <div className="jp_listing_overview_list_main_wrapper jp_listing_overview_list_main_wrapper2">
                    <div className="jp_listing_list_icon">
                      <i className="fa fa-info-circle" />
                    </div>
                    <div className="jp_listing_list_icon_cont_wrapper">
                      <ul>
                        <li>Pozisyon Tanımı</li>
                        <li>{post?.position_name}</li>
                      </ul>
                    </div>
                  </div>
                  <div className="jp_listing_overview_list_main_wrapper jp_listing_overview_list_main_wrapper2">
                    <div className="jp_listing_list_icon">
                      <i className="fa fa-clock-o" />
                    </div>
                    <div className="jp_listing_list_icon_cont_wrapper">
                      <ul>
                        <li>Çalışma Şekli</li>
                        <li>{post?.work_style === "Is yerinde" ? 'İş Yerinde' : (post?.work_style === "Hibrid" ? "Hibrid" : "Uzaktan")}</li>
                      </ul>
                    </div>
                  </div>
                  <div className="jp_listing_overview_list_main_wrapper jp_listing_overview_list_main_wrapper2">
                    <div className="jp_listing_list_icon">
                      <i className="fa fa-th-large" />
                    </div>
                    <div className="jp_listing_list_icon_cont_wrapper">
                      <ul>
                        <li>Kategori</li>
                        <li>{post?.position_category}</li>
                      </ul>
                    </div>
                  </div>
                  <div className="jp_listing_overview_list_main_wrapper jp_listing_overview_list_main_wrapper2">
                    <div className="jp_listing_list_icon">
                      <i className="fa fa-star" />
                    </div>
                    <div className="jp_listing_list_icon_cont_wrapper">
                      <ul>
                        <li>Deneyim</li>
                        <li>{post?.experience_required} yıl deneyim</li>
                      </ul>
                    </div>
                  </div>
                  <div className="jp_listing_right_bar_btn_wrapper">
                    <div className="jp_listing_right_bar_btn" style={{ marginLeft: -17 }}>
                      <ul>
                        <li>
                          <a
                            href={
                              post?.job_link?.startsWith("http")
                                ? post.job_link
                                : `https://${post?.job_link}`
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            İlan Lİnkİ
                          </a>

                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>
      </>


  );
}

export default ShowFastJobPost